import '@/styles.css'

import { registerWebComponents } from './register'
import { injectBeeetleBotInWindow, parseBeeetleBot } from './window'


registerWebComponents()

const BeeetleBot = parseBeeetleBot()

injectBeeetleBotInWindow(BeeetleBot)


export default BeeetleBot